export const status_list = [

    {
        label: '全部',
        value: 0
    },
    {
        label: '待提交',
        value: 'edit'
    },
    {
        label: '审批中',
        value: 'normal'
    },
    {
        label: '已完成',
        value: 'finished'
    },
]

export const search_type_list = [
    {
        label: '全部',
        value: 0
    },
    {
        label: '我发起的',
        value: 'mine'
    },
    {
        label: '待我处理',
        value: 'pending'
    },
    {
        label: '与我相关的',
        value: 'related'
    },
]